import { QuantityRangeDto, ScaleDto } from '@/api-sdk';
import { RowData } from '@/types';
import { t } from 'i18next';

/**
 * The function makeColumnHeadingsArrayFromQuantityRanges is used to create an array of column headings from quantity ranges
 * @param quantityRanges object of quantity ranges
 * @param offset boolean to add an empty string to the beginning of the array to set first column as empty. This is used when the first cell in a row is a description instead of a quantity range
 * @returns function that returns an array of column headings as strings
 */
export function makeColumnHeadingsArrayFromQuantityRanges(
  quantityRanges: QuantityRangeDto[],
  offset?: boolean,
) {
  return () => {
    const headings = offset ? [''] : [];
    quantityRanges.map(quantityRange =>
      headings.push(
        `${quantityRange.minimumQuantity}${
          quantityRange.maximumQuantity
            ? ` - ${quantityRange.maximumQuantity}`
            : `+`
        } ${t('content.pieces')}`.toString(),
      ),
    );
    return headings;
  };
}

/**
 * Creates an array of row data objects from the given scales.
 *
 * This function takes an array of scales and maps each scale to a row data object.
 * Each row data object contains the name of the scale and an array of tier prices.
 * The tier prices array includes objects with formatted main and sub values.
 *
 * @param scales - The array of scales to be processed.
 * @returns An array of row data objects.
 */
export function makeColumnRowsArrayFromScales(scales: ScaleDto[]) {
  const columnRowsArray: RowData = [];
  scales.map(scale => {
    const rowValueMapping = scale?.tierPrices.map(tierPrice => {
      return {
        mainValue: tierPrice.price.formatted,
        subValue: tierPrice.grossPrice?.formatted,
      };
    });
    columnRowsArray.push({
      rowName: scale?.name,
      rowValues: rowValueMapping,
    });
  });
  return columnRowsArray;
}
